import React, { useState, useEffect } from "react";
import FastMarquee from "react-fast-marquee";
import styled from "@emotion/styled";
import { Colors } from "./colors";
import { useNavigate } from "react-router-dom";
import { shuffle } from "../util";
import { useTranslation } from 'react-i18next';
import { useCompanies } from "../contexts/CompanyContext";
const LogoWall = () => {
  const {companies} = useCompanies();
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();

  return (
    <Container>
      <Title>{t("main_featured_companies")}</Title>
      <Marquee>
        <div dir="ltr">
          <FastMarquee gradientColor={[255, 255, 255]} speed={40} direction="right">
            {companies.filter(company => company.company_website).map((company, index) => (
              <CompanyLogo
                key={index}
                src={`https://img.logo.dev/${company.company_website}?token=pk_M0m3xPUmQQaKLD399NpbYw`}
                alt={`Logo ${index + 1}`}
                onClick={() => navigate(`/companies/${company.company_name}`)}
              />
            ))}
          </FastMarquee>
        </div>
      </Marquee>
    </Container>
  );
};

const Container = styled.div`
  text-align: center;
  padding: 20px;
  margin-bottom: 15px;
  background: linear-gradient(to left, white, #f2f2f2);
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  color: ${Colors.white};
  z-index:2;
`;

const Title = styled.h2`
  font-size: 24px;
  margin-bottom: 20px;
  margin-top: 10px;
  color: ${Colors.black};
`;

const Marquee = styled.div`
  border-radius: 12px;
  overflow: hidden;
`;

const CompanyLogo = styled.img`
  width: 70px;
  height: auto;
  margin: 0 45px; /* Increased margin */
  border-radius: 8px;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(0.9);
    cursor: pointer;
  }
`;

export default LogoWall;
